import React from 'react';

import { Link } from 'react-router-dom';
import './tutores.css';

function TutorLanding({ tutor }) {
  const { id, nombre, apellido, foto, profesion } = tutor;

  return (
    <Link to={`/cursos/${id}`}>
      <div className="entrada-tutor-landing">
        <div className="imagen-tutor-landing">
          <img src={`https://backend.codigolimpio.es/${foto}`} alt="" />
        </div>

        <div className="info-tutor-landing">
          <p>
            <strong>
              {nombre} {apellido}
            </strong>
            <br></br>

            {profesion}
          </p>
        </div>
      </div>
    </Link>
  );
}

export default TutorLanding;
